import { Component, EventEmitter, Input, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'nx-ng-submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.scss'],
})
export class SubmitButtonComponent {
  @Input()
  labelKey = '';

  @Input()
  disabled = false;

  @Input()
  type: 'submit' | 'button' = 'submit';

  @Input()
  isGhostButton = false;

  @Output()
  submitted: EventEmitter<boolean> = new EventEmitter<boolean>();

  public id = uuidv4();

  submit = () => this.submitted.emit(true);
}
